// extracted by mini-css-extract-plugin
module.exports = {"message":"_1221"};